module.exports = __webpack_public_path__ + "static/organicgeometricmain-8309e4fe4f0215cd90e59c756ead46e1.png";